import { ReactComponent as Glass } from "../images/materials/bs_machinery-glass.svg";
import { ReactComponent as Materia } from "../images/materials/bs_machinery-materia.svg";
import { ReactComponent as Metal } from "../images/materials/bs_machinery-metal.svg";
import { ReactComponent as Stone } from "../images/materials/bs_machinery-stone.svg";
import { ReactComponent as Wood } from "../images/materials/bs_machinery-wood.svg";
import { MaterialType } from "../types/materials";

const materialLogo = {
  [MaterialType.Stone]: Stone,
  [MaterialType.Glass]: Glass,
  [MaterialType.Wood]: Wood,
  [MaterialType.Materia]: Materia,
  [MaterialType.Metal]: Metal,
};

export function getMaterialLogo(material: MaterialType) {
  return materialLogo[material];
}
